import React from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  const { t } = useLang();
  const tst = t.testimonials;
  const ref = useReveal();

  return (
    <section className="bg-[#f4f6f9] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="section-line" />
            <span className="text-xs font-700 uppercase tracking-[0.25em] font-display text-[#f5871f]">
              {tst.eyebrow}
            </span>
            <span className="section-line" />
          </div>
          <h2 className="font-display font-700 text-3xl md:text-4xl uppercase text-[#0d2140]">{tst.title}</h2>
        </div>

        <div ref={ref} className="reveal mt-14 grid md:grid-cols-3 gap-8">
          {tst.items.map((item, i) => (
            <div key={i} className="card-hover bg-white rounded-2xl border border-[#0d2140]/10 p-8 flex flex-col">
              <Quote className="w-9 h-9 text-[#f5871f]/30" />
              <p className="mt-4 text-[#0d2140]/80 text-sm leading-relaxed flex-1">“{item.quote}”</p>
              <div className="mt-6 flex gap-0.5">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 text-[#f5871f] fill-[#f5871f]" />
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-[#0d2140]/10">
                <div className="font-display font-700 text-[#0d2140] uppercase text-sm">{item.name}</div>
                <div className="text-[#0d2140]/50 text-xs mt-0.5">{item.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
